import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EvaluationRoutingModule } from './evaluation-routing.module';

import { SharedModule } from 'src/app/shared/shared.module';
import { EvaluationComponentsModule } from '@app-components/evaluation/evaluation-components.module';
import { EvalsDashboardsComponent } from '../evals-dashboards/evals-dashboards.component';
import { EvalsDashboardsModule } from '../evals-dashboards/evals-dashboards.module';


@NgModule({
  declarations: [

  ],
  imports: [
    CommonModule,
    EvaluationRoutingModule,
    EvaluationComponentsModule,
    SharedModule,
    EvalsDashboardsModule
  ]
})
export class EvaluationModule { }
